import { BaseService } from "services/_baseService";

class PermissionsAdminService extends BaseService<any> {
  constructor() {
    super(`permissions`);
  }
}

export default new PermissionsAdminService();
